import { getPreloadResult } from './PreloadResult';

export function restQuery(
	url: string,
	{
		method,
		headers,
		body,
		claimKey,
	}: {
		method: string;
		headers?: HeadersInit;
		body?: { [key: string]: any };
		claimKey?: string;
	},
) {
	const variables = { method, ...body, ...headers };

	return getPreloadResult().load(claimKey ? { name: claimKey } : { name: url, variables }, () =>
		// eslint-disable-next-line no-restricted-syntax, check-credentials-option/has-credentials-option
		fetch(url, {
			method,
			credentials: 'include',
			headers,
			body: JSON.stringify(body),
		}),
	);
}
